import * as React from 'react';
import { Link } from 'react-router-dom';
import { Button, Grid, Typography } from '@mui/material';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import useRoot from 'hooks/use-root';

const Forbidden = () => {
  const { defaultPage } = useRoot();
  return (
    <Grid
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      gap="25px"
      height="100%"
    >
      <SentimentVeryDissatisfiedIcon color="error" sx={{ fontSize: '50px' }} />
      <Typography textAlign="center" variant="h4">
        You do not have permission to view the content!
      </Typography>
      <Link to={defaultPage}>
        <Button variant="contained">Go home</Button>
      </Link>
    </Grid>
  );
};

export default Forbidden;
